export default __webpack_public_path__ + "static/list-childs-0a712c1eee5fc89c1b91e49928b376ab.png";